import { POST } from "../APiHelper/API"

export const checkWyScoutBenchAvailableAPI = (data, onSuccess, onError) => {

    // const data = {
    //     fixture_id: fixture_id,
    //     team_id: team_id,
    // }

    POST(`/api/v1/squads/check_wyscout_bench`, data, onSuccess, onError);

}